import React from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  FormGroup,
  Form,
  Label,
  Row,
  Col,
  Input,
  CustomInput,
} from 'reactstrap'
import get from 'lodash/get'
import shortid from 'shortid'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'
import { hardware_type } from '../../constants'

class AddHardwareForm extends React.Component {
  render() {
    const open = get(this.props, 'open')
    const toggle = get(this.props, 'toggle')
    const hardware_cost = get(this.props, 'hardware_cost')
    const hardware_price = get(this.props, 'hardware_price')
    const handleInput = get(this.props, 'handleInput')
    return (
    /* eslint no-underscore-dangle: 0 */
      <Modal
        isOpen={ open }
        toggle={ () => toggle() }
      >
        <ModalHeader toggle={ () => toggle() }>
          <HeadText>Add Hardware</HeadText>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm="12">
              <Form onSubmit={ (e) => e.preventDefault() }>
                <FormGroup>
                  <Container >
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Type</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <CustomInputField
                          type="select"
                          name="hardware_type"
                          value={ get(this.props, 'hardware_type') }
                          onChange={ (e) => handleInput(e) }
                        >
                          { hardware_type.map((t) =>
                            <option key={ shortid() } value={ t.value }>{ t.label }</option>
                          ) }
                        </CustomInputField>
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Sub-Project Code</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <InputField
                          name="hardware_sub_project_code"
                          onBlur={ (e) => handleInput(e) }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Hardware Name</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <InputField
                          name="hardware_name"
                          onBlur={ (e) => handleInput(e) }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Description</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <InputField
                          name="hardware_description"
                          onBlur={ (e) => handleInput(e) }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Total Cost (฿)</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <NumberFieldSub
                          name="hardware_cost"
                          value={ hardware_cost }
                          allowEmptyFormatting={ true }
                          thousandSeparator={ true }
                          decimalScale={ 2 }
                          fixedDecimalScale={ true }
                          onBlur={ (e) => {
                            e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                            handleInput(e)
                          } }
                        />
                      </Col>
                    </Row>
                    <Row style={ { marginTop: 10 } }>
                      <Col sm={ 4 }>
                        <TextLabel >Sale Price (฿)</TextLabel>
                      </Col>
                      <Col sm={ 8 }>
                        <NumberFieldSub
                          name="hardware_price"
                          value={ hardware_price }
                          allowEmptyFormatting={ true }
                          thousandSeparator={ true }
                          decimalScale={ 2 }
                          fixedDecimalScale={ true }
                          onBlur={ (e) => {
                            e.target.value = parseFloat(e.target.value.replace(/,/g, ''))
                            handleInput(e)
                          } }
                        />
                      </Col>
                    </Row>
                  </Container>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          { get(this.props, 'button') }
        </ModalFooter>
      </Modal>
    )
  }
}

export default AddHardwareForm

const InputField = styled(Input)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const HeadText = styled(Label)`
    font-family: 'Gotham-Bold' !important;
    font-size: 16px ;
    color: #AD2624;
`
const TextLabel = styled(Label)`
    font-family: 'Gotham-Bold' !important;
    font-size: 14px ;
    color: #404040;
`
const CustomInputField = styled(CustomInput)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height : 100% ;
    font-size: 12px ;
`
const NumberFieldSub = styled(NumberFormat)`
    font-family: 'Gotham' !important;
    width : 100% ;
    height: 100%;
    font-size: 12px ;
    border-radius: 5px;
    border: ${props => {
    if (props.invalid) {
      return '1px solid red'
    }
    return '1px solid #CCCCCC'
  }};
    background-color: ${props => {
    const status = props.disabled
    if (status === !get(this.props, 'edit_resource')) {
      return '#E8ECEF'
    }
    return '#FFFFFF'
  }};
`




// WEBPACK FOOTER //
// ./src/components/project-information/form/add-hardware/index.js